import {Observable} from 'rxjs';
import {educatAPI, RestQueryParams} from 'educat-common-web';


export function getMentorAPI(mentorId: string | null | undefined, authToken: string | null | undefined): Observable<any> {
    let headers = undefined;
    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }
    return educatAPI.get(
        `mentors/${mentorId}`,
        new RestQueryParams(),
        headers
    );
}
